import React from 'react';
import { Card } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { renderLegends } from '../../../../support/SingleLeyendLabel';

import ComplementoSummaryActionButtons from '../components/ComplementoSummaryActionButtons';

const ComplementoInteresesHipotecariosResumen = ({ data = [], onEdit, onDelete, onListChange }) => {
  const handleOnDelete = () => {
    onDelete('Intereseshipotecarios');
  }

  const handleOnEdit = () => {
    onEdit('Intereseshipotecarios', data);
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Intereses Hipotecarios, Versión { data.Version }</Card.Subtitle>

        <Row className="mt-3 mb-4">
          <Col className="mb-2">
            { labels.map(renderLegends(data, { width: 500, addSemicolon: true })) }
          </Col>
        </Row>

        <ComplementoSummaryActionButtons onEdit={ handleOnEdit} onDelete={ handleOnDelete } />
      </Card.Body>
    </Card>
  )
}
const labels = [
  {
    label: 'Crédito otorgado por institución financiera',
    index: 'CreditoDeInstFinanc'
  },
  {
    label: 'Saldo insoluto',
    index: 'SaldoInsoluto'
  },
  {
    label: 'Monto total intereses nominales devengados',
    index: 'PropDeducDelCredit'
  },
  {
    label: 'Monto retención Extranjero',
    index: 'MontTotIntNominalesDev'
  },
  {
    label: 'Monto total intereses nominales devengados y pagados',
    index: 'MontTotIntNominalesDevYPag'
  },
  {
    label: 'Monto total intereses reales pagados deducibles',
    index: 'MontTotIntRealPagDeduc'
  },
  {
    label: 'Número de contrato del crédito hipotecario',
    index: 'NumContrato'
  },
];

export default ComplementoInteresesHipotecariosResumen
